/**
 * Maps a D365 production-order status to a chip style. Mirrors the visual language of
 * getLineStatusChipStyle but with production-lifecycle semantics (Created → Estimated →
 * Scheduled → Released → Started → Reported as finished → Completed/Ended).
 */
export function getProductionOrderStatusChipStyle(
    status: string,
    isDark = false,
): { backgroundColor: string; color: string } {
    switch (status.toLowerCase()) {
        case "completed":
        case "ended":
        case "reported as finished":
            return isDark
                ? { backgroundColor: "rgba(76, 175, 80, 0.2)", color: "#81c784" }
                : { backgroundColor: "#c8e6c9", color: "#2e7d32" };
        case "started":
            return isDark
                ? { backgroundColor: "rgba(33, 150, 243, 0.2)", color: "#90caf9" }
                : { backgroundColor: "#bbdefb", color: "#1565c0" };
        case "released":
        case "scheduled":
            return isDark
                ? { backgroundColor: "rgba(255, 152, 0, 0.2)", color: "#ffcc80" }
                : { backgroundColor: "#fff9c4", color: "#f57f17" };
        case "estimated":
        case "created":
            return isDark
                ? { backgroundColor: "rgba(149, 117, 205, 0.2)", color: "#b39ddb" }
                : { backgroundColor: "#e1bee7", color: "#6a1b9a" };
        default:
            return isDark
                ? { backgroundColor: "rgba(255, 255, 255, 0.08)", color: "#bdbdbd" }
                : { backgroundColor: "#e0e0e0", color: "#424242" };
    }
}
